<template>
    <div id="container-information-panel-carousel">
      <div id="title-indicator">
        <span v-if="title">{{ title }}</span>
        <span v-else>{{ title_static }}</span>
      </div>
      <div id="body-indicators">
        <div
          v-for="(item,i) in indicators"
          :key="i"
          id="content-icons"
        >
          <img
            v-if="i == index"
            :id="item.id"
            :src="Get_Image(item.src_hover)"
          >
          <img
            v-else
            :id="item.id"
            :src="Get_Image(item.src)"
            @mouseover="Change_Src(item.src_hover,item.id); title = item.title"
            @mouseleave="Change_Src(item.src,item.id); title = indicators[index].title"
            @click="Change_Index(i)"
          >
        </div>
      </div>
    </div>
  </template>

  <script>

  import { mapState, mapActions } from 'vuex'

  export default {
    name: 'IndicatorsInformationCarousel',

    data () {
      return {
        title: this.title_static
      }
    },

    props: {
      indicators: Object
    },
    computed: {
      ...mapState(['index']),

      title_static () {
        return this.indicators[this.index].title
      }
    },

    methods: {
      ...mapActions(['Change_Index']),

      Get_Image (src) {
        return (require(`../../assets/images/cards/${src}`))
      },

      Change_Src (change, id) {
        document.getElementById(id).src = (require(`../../assets/images/cards/${change}`))
      }
    }
  }

  </script>

  <style scoped>

  #container-information-panel-carousel {
    width: 10em;
    border: 1px solid lightgray;
    border-radius: .3em;
    margin-left: 10em;
  }
  #title-indicator {
    background-color: rgba(85, 85, 85, 0.8);
    width: 100%;
    padding: .5em .5em;
    cursor: default;
    border-radius: .3em;
  }
  #title-indicator span {
    border-radius: .3em;
    box-shadow: .1em .1em .1em .1em rgba(95, 95, 95, .5);
    padding: 0 .1em;
    font-size: 90%;
    color: white;
    display: flex;
    font-family: "Ancizar-regular", Helvetica, Arial;
    text-align: center;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 4em;
  }
  #body-indicators {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    overflow-y: auto;
  }
  #content-icons {
    margin: 1em 1em;
  }
  #content-icons img {
    width: 3em;
    height: 3em;
    cursor: pointer;
  }
  @media (max-width: 769px) {
    #container-information-panel-carousel {
      width: 100%;
      margin-bottom: 1rem;
    }
    #body-indicators {
      flex-direction: row;
      height: 5em;
    }
  }
</style>